module.exports = __webpack_public_path__ + "static/hyperv_28.40aa93d6.jpg";